import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  ActionDetailsWrapper,
  DetailLabel,
  DetailInfo,
  ActionDetailsButton,
} from "./actionDetailsStyles.js";
import { ActionRequest } from "../../_globalTypes/index.js";

const localDate = (apiDate) => {
  const utcDateTime = apiDate;
  const localDateTime = new Date(utcDateTime);
  const currentLocalDate = `${
    localDateTime.getMonth() + 1
  }/${localDateTime.getDate()}/${localDateTime.getFullYear()}`;

  return currentLocalDate;
};

const siteMapper = {
  1: "AmericanBlinds.com",
  2: "Blinds.ca",
  3: "Blinds.com",
  5: "JustBlinds.com",
  11: "HomeDepot.com & Instore Design Builder",
};

const ActionDetails = (props) => {
  const {
    id,
    productName,
    originalProductId,
    siteId,
    requestName,
    // lastModifiedOn,
    // expectedGoLiveDate,
    comments,
    isBeingReviewed,
    requestDate,
    // siteName,
  } = props;
  const date = requestDate;

  const checkForCommments = () => {
    if (!comments || comments.trim().length === 0) {
      return "No comments";
    }

    return comments;
  };

  return (
    <ActionDetailsWrapper>
      <DetailLabel>Product:</DetailLabel>
      <DetailInfo>{productName}</DetailInfo>
      <DetailLabel>Product ID:</DetailLabel>
      <DetailInfo>{originalProductId}</DetailInfo>
      <DetailLabel>Website:</DetailLabel>
      <DetailInfo>{siteMapper[siteId]}</DetailInfo>
      <DetailLabel>Request Date:</DetailLabel>
      <DetailInfo>{localDate(date)}</DetailInfo>
      <DetailLabel>Request Name:</DetailLabel>
      <DetailInfo>{requestName}</DetailInfo>
      {/* <DetailLabel>Expected Go Live Date:</DetailLabel>
      <DetailInfo>{localDate(expectedGoLiveDate)}</DetailInfo> */}
      <DetailLabel>Comments to the Vendor:</DetailLabel>
      <DetailInfo>{checkForCommments()}</DetailInfo>
      {!isBeingReviewed && (
        <Link to={`/Vendor/myproducts?actionId=${id}`}>
          <ActionDetailsButton type="secondary" label="Review Request" />
        </Link>
      )}
    </ActionDetailsWrapper>
  );
};

ActionDetails.propTypes = {
  ...ActionRequest,
  isBeingReviewed: PropTypes.bool.isRequired,
};
ActionDetails.defaultProps = {
  requestDate: null,
  requestName: "",
  expectedGoLiveDate: null,
  status: 0,
  previewUrl: "",
  comments: "THIS IS A TEST COMMENT.",
  originalProductId: 9999,
  siteName: "HomeDepot.com",
};

export default ActionDetails;
